import React from "react";
import { Typography } from "@mui/material";

interface Props {
  label: string;
  value: any;
}

const FormatAndDisplay: React.FC<Props> = ({ label, value }) => {
  const formatValue = (value: any) => {
    if (typeof value === "string") {
      return value;
    } else if (value instanceof Date) {
      return value.toLocaleDateString();
    } else if (typeof value === "boolean") {
      return value ? "Sim" : "Não";
    } else {
      return value ? value.toString() : "";
    }
  };

  return (
    <Typography>
      {label}: {formatValue(value)}
    </Typography>
  );
};

export default FormatAndDisplay;
